function initFlatOutPrice(root) {
  if (root.dataset.fopInit) return;
  root.dataset.fopInit = 'true';

  var button = root.querySelector('[data-fop-copy]');
  var textEl = root.querySelector('[ref="fopCodeText"]');
  if (!button) return;

  var resetTimer = null;

  button.addEventListener('click', function () {
    var code = root.dataset.fopCode || '';
    if (!code) return;

    function showCopied() {
      button.classList.add('is-copied');
      var originalText = textEl ? textEl.textContent : '';
      if (textEl) textEl.textContent = 'Copied!';
      clearTimeout(resetTimer);
      resetTimer = setTimeout(function () {
        button.classList.remove('is-copied');
        if (textEl) textEl.textContent = originalText;
      }, 1800);
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(showCopied).catch(function () {
        fallbackCopy(code);
        showCopied();
      });
    } else {
      fallbackCopy(code);
      showCopied();
    }
  });

  function fallbackCopy(text) {
    var input = document.createElement('textarea');
    input.value = text;
    input.style.position = 'fixed';
    input.style.opacity = '0';
    document.body.appendChild(input);
    input.select();
    try {
      document.execCommand('copy');
    } catch (e) {
      /* no-op: clipboard access unavailable, code is still visible to copy manually */
    }
    document.body.removeChild(input);
  }
}

document.querySelectorAll('.fop').forEach(initFlatOutPrice);
